<div class="nav-container">
  <nav id="main-menu-navigation" class="navigation-main">
    <!-- <div class="nav-item "  routerLinkActive="active" >
        <a  id="mnRoleview" [routerLink]="['/auth/basic-data/role-view']"  ngbTooltip="{{'menu.role' | translate}}"> <img src="assets/images/role.png" class="img-fluid" alt="SEU"><span>{{'menu.role' | translate}}</span></a>
    </div>
    <div id="mnRolePer" class="nav-item "  routerLinkActive="active" >
        <a [routerLink]="['/admin/permission-role']"  ngbTooltip="{{'menu.role' | translate}}"> <img src="assets/images/role.png" class="img-fluid" alt="SEU"><span>{{'menu.role' | translate}}</span></a>
    </div>
    <div id="mnUserRole" class="nav-item "  routerLinkActive="active" >
        <a [routerLink]="['/admin/user-role']"  ngbTooltip="{{'menu.role' | translate}}"> <img src="assets/images/role.png" class="img-fluid" alt="SEU"><span>صلاحية المستخدم </span></a>
    </div>
    <div class="nav-item has-sub open  ">
        <a href="javascript:void(0)"  ngbTooltip="{{'admin.usersmanagement' | translate}}"> <img src="assets/images/user2.png" class="img-fluid" alt="SEU"><span>{{'admin.usersmanagement' | translate}}</span></a>
        <div class="submenu-content">
             <a id="mnUserView"  routerLinkActive="active"  class="menu-item" [routerLink]="['/auth/basic-data/user-view']" ><img src="assets/images/userv.png" class="img-fluid" alt="SEU">{{'admin.usersview' | translate}}</a>
             <a id="mnImportUser"  routerLinkActive="active"   class="menu-item" [routerLink]="['/auth/basic-data/import-user']" ><img src="assets/images/import.png" class="img-fluid" alt="SEU">{{'admin.usersimport' | translate}}</a>

        </div>
    </div>

    <div class="nav-item has-sub open ">
        <a href="javascript:void(0)"  ngbTooltip="{{'admin.Basicdata' | translate}}"> <img src="assets/images/data.png" class="img-fluid" alt="SEU"><span>{{'admin.Basicdata' | translate}}</span></a>
        <div class="submenu-content">
            <a id="mnCoursesview"  routerLinkActive="active"  class="menu-item" [routerLink]="['/auth/basic-data/courses-view']"> <img src="assets/images/course.png" class="img-fluid" alt="SEU">{{'admin.Courses' | translate}}</a>
            <a id="mnCollegesview" routerLinkActive="active"  class="menu-item" [routerLink]="['/auth/basic-data/colleges-view']"> <img src="assets/images/college.png" class="img-fluid" alt="SEU">{{'admin.Colleges' | translate}}</a>
            <a id="mnProgramsview" routerLinkActive="active"  class="menu-item" [routerLink]="['/auth/basic-data/programs-view']"> <img src="assets/images/prog.png" class="img-fluid" alt="SEU">{{'admin.Programs' | translate}}</a>
            <a id="mnSectionsview" routerLinkActive="active"  class="menu-item" [routerLink]="['/auth/basic-data/sections-view']"> <img src="assets/images/group.png" class="img-fluid" alt="SEU">{{'admin.sections' | translate}}</a>

        </div>
    </div> -->

    <!-- <div class="nav-item">
      <a routerLink="" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [routerLink]="['landind']">
        <img src="assets/images/doctors.png" class="img-fluid" alt="SEU"><span>المنصة العلاجية</span></a>
    </div> -->

    <div id="mnUserRole" class="nav-item" routerLinkActive="active">
      <a
        [routerLink]="['/admin/users']"
        ngbTooltip="{{ 'menu.role' | translate }}"
      >
        <!-- <img src="assets/images/role.png" class="img-fluid" alt="SEU"> -->
        <img
          src="assets/images/icons/users-1.svg"
          class="img-fluid"
          alt="users icon"
          style="width: 24px"
        />
        <span>قائمة المستخدمين </span></a
      >
    </div>

    <!-- <div class="nav-item">
        <a routerLink="" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [routerLink]="['/Sas/Patient-profile']"> <img src="assets/images/ava.png" class="img-fluid" alt="SEU"><span>الملف الشخصي</span></a>
    </div> -->
    <div class="nav-item">
      <a
        routerLink=""
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/auth/basic-data/PatientsView']"
      >
        <!-- <img src="assets/images/users.png" class="img-fluid" alt="SEU" /> -->
        <img
          src="assets/images/icons/users-2.svg"
          class="img-fluid"
          alt="users icon"
          style="width: 24px"
        />

        <span>قائمة المرضى</span></a
      >
    </div>

    <!-- المتخصصين -->
    <div class="nav-item has-sub" routerLinkActive="active">
      <a href="javascript:void(0)">
        <!-- <img src="assets/images/medical-team.png" class="img-fluid" alt="SEU" /> -->
        <img
          src="assets/images/icons/doctor.svg"
          class="img-fluid"
          alt="doctor icon"
          style="width: 24px"
        />

        <span>الاخصائيون</span>
      </a>

      <div class="submenu-content">
        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/Spcialist-schedule']"
        >
          <!-- <img
            src="assets/images/medical-team.png"
            class="img-fluid"
            alt="SEU"
          /> -->
          <img
            src="assets/images/icons/users-2.svg"
            class="img-fluid"
            alt="users icon"
            style="width: 24px"
          />

          <span>قائمة المتخصصين</span></a
        >

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/auth/basic-data/spcialist']"
        >
          <!-- <img
            src="assets/images/doctor.png"
            class="img-fluid"
            alt="SEU"
          /> -->
          <img
            src="assets/images/icons/doctor.svg"
            class="img-fluid"
            alt="doctor icon"
            style="width: 24px"
          />

          <span>إضافة متخصص</span></a
        >
      </div>
    </div>

    <!-- المشرفين -->
    <div class="nav-item has-sub" routerLinkActive="active">
      <a href="javascript:void(0)">
        <!-- <img src="assets/images/userv.png" class="img-fluid" alt="SEU" /> -->
        <img
          src="assets/images/icons/users-2.svg"
          class="img-fluid"
          alt="users icon"
          style="width: 24px"
        />

        <span>المشرفين</span>
      </a>

      <div class="submenu-content">
        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/SupervaisorView']"
        >
          <!-- <img src="assets/images/users.png" class="img-fluid" alt="SEU" /> -->
          <img
            src="assets/images/icons/users-2.svg"
            class="img-fluid"
            alt="users icon"
            style="width: 24px"
          />

          <span>قائمة المشرفين</span></a
        >

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/SupervaisorForm']"
        >
          <!-- <img
            src="assets/images/doctor.png"
            class="img-fluid"
            alt="SEU"
          /> -->
          <img
            src="assets/images/icons/doctor.svg"
            class="img-fluid"
            alt="doctor icon"
            style="width: 24px"
          />

          <span>إضافة مشرف</span></a
        >

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/auth/basic-data/assign-specialists']"
        >
          <!-- <img
            src="assets/images/plusq.png"
            class="img-fluid"
            alt="SEU"
          /> -->
          <img
            src="assets/images/icons/plus-icon.svg"
            class="img-fluid"
            alt="plus icon"
            style="width: 24px"
          />

          <span> إضافة متخصص لمشرف</span></a
        >
      </div>
    </div>

    <!-- <div class="nav-item">
      <a routerLink="" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
        [routerLink]="['/auth/basic-data/Booking']"> <img src="assets/images/calendar.png" class="img-fluid"
          alt="SEU"><span>حجز المواعيد</span></a>
    </div> -->

    <!-- <div class="nav-item">
      <a routerLink="" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
        [routerLink]="['/Sas/Schedule']"> <img src="assets/images/medical-team.png" class="img-fluid" alt="SEU"><span>
          استخراج مواعيد</span></a>
    </div>
    <div class="nav-item">
      <a routerLink="" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
        [routerLink]="['/Sas/My-Schedule']"> <img src="assets/images/medical-file.png" class="img-fluid"
          alt="SEU"><span>جدول الجلسات</span></a>
    </div> -->

    <!-- الإعدادت -->
    <div class="nav-item has-sub" routerLinkActive="active">
      <a href="javascript:void(0)">
        <!-- <img src="assets/images/userv.png" class="img-fluid" alt="SEU" /> -->
        <img
          src="assets/images/icons/dashboard-settings.svg"
          class="img-fluid"
          alt="dashboard settings icon"
          style="width: 24px"
        />

        <span>الإعدادت</span>
      </a>

      <div class="submenu-content">
        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/admin/configuration']"
        >
          <!-- <img src="assets/images/gmail.png" class="img-fluid" alt="SEU" /> -->
          <img
            src="assets/images/icons/mail-icon.svg"
            class="img-fluid"
            alt="mail icon"
            style="width: 24px"
          />

          <span>البريد الإلكترونى</span></a
        >

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/admin/ZoomUsers']"
        >
          <!-- <img src="assets/images/users.png" class="img-fluid" alt="SEU" /> -->
          <img
            src="assets/images/icons/users-2.svg"
            class="img-fluid"
            alt="users icon"
            style="width: 24px"
          />

          <span>حسابات زووم</span></a
        >
      </div>
    </div>

    <!-- باقات الدفع -->
    <div class="nav-item has-sub" routerLinkActive="active">
      <a href="javascript:void(0)">
        <!-- <img src="assets/images/money-icon.png" class="img-fluid" alt="SEU" /> -->
        <img
          src="assets/images/icons/coins.svg"
          class="img-fluid"
          alt="coins icon"
          style="width: 24px"
        />

        <span>باقات الدفع</span>
      </a>

      <div class="submenu-content">
        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/Subscriptions-View']"
        >
          <!-- <img
            src="assets/images/money-bag-icon.png"
            class="img-fluid"
            alt="SEU"
          /> -->
          <img
            src="assets/images/icons/money-bag.svg"
            class="img-fluid"
            alt="money bag icon"
            style="width: 24px"
          />

          <span> الباقات الحالية</span></a
        >

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/AddSubscription']"
        >
          <!-- <img
            src="assets/images/plusq.png"
            class="img-fluid"
            alt="SEU"
          /> -->
          <img
            src="assets/images/icons/plus-icon.svg"
            class="img-fluid"
            alt="plus icon"
            style="width: 24px"
          />
          <span> إضافة باقة</span></a
        >
      </div>
    </div>

    <!-- التخصصات -->
    <div class="nav-item has-sub" routerLinkActive="active">
      <a href="javascript:void(0)">
        <!-- <img src="assets/images/data.png" class="img-fluid" alt="SEU" /> -->
        <img
          src="assets/images/icons/computer.svg"
          class="img-fluid"
          alt="computer icon"
          style="width: 24px"
        />
        <span>التخصصات</span>
      </a>

      <div class="submenu-content">
        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/MainSpeciality-View']"
        >
          <!-- <img
            src="assets/images/course.png"
            class="img-fluid"
            alt="SEU"
          /> -->
          <img
            src="assets/images/icons/book-open.svg"
            class="img-fluid"
            alt="book open icon"
            style="width: 24px"
          />
          <span>التخصصات الرئيسية</span></a
        >

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/SubSpeciality-View']"
        >
          <!-- <img
            src="assets/images/course.png"
            class="img-fluid"
            alt="SEU"
          /> -->
          <img
            src="assets/images/icons/book-open.svg"
            class="img-fluid"
            alt="book open icon"
            style="width: 24px"
          />
          <span>التخصصات الفرعية</span></a
        >

        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/Doctors-View']"
        >
          <!-- <img
            src="assets/images/group.png"
            class="img-fluid"
            alt="SEU"
          /> -->
          <img
            src="assets/images/icons/users-2.svg"
            class="img-fluid"
            alt="users icon"
            style="width: 24px"
          />

          <span> الاخصائيين العاملين معنا </span></a
        >
      </div>
    </div>

    <!-- الأخبار -->
    <div class="nav-item has-sub" routerLinkActive="active">
      <a href="javascript:void(0)">
        <!-- <img src="assets/images/news.png" class="img-fluid" alt="SEU" /> -->
        <img
          src="assets/images/icons/news.svg"
          class="img-fluid"
          alt="news icon"
          style="width: 24px"
        />

        <span>الأخبار</span>
      </a>

      <div class="submenu-content">
        <a
          class="menu-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="['/Sas/News-View']"
        >
          <!-- <img src="assets/images/news.png" class="img-fluid" alt="SEU" /> -->
          <img
            src="assets/images/icons/news.svg"
            class="img-fluid"
            alt="news icon"
            style="width: 24px"
          />

          <span> الأخبار </span></a
        >
      </div>
    </div>

    <!-- <div class="nav-item has-sub ">
      <a href="javascript:void(0)"> <img src="assets/images/online.png" class="img-fluid" alt="SEU">
        <span> خدمة التشخيص</span>
      </a>
      <div class="submenu-content">
        <a href="#" class="menu-item"><i class="ik ik-menu"></i>التعريف بالخدمة</a>
        <a href="#" class="menu-item"><i class="ik ik-menu"></i>الدفع </a>
        <a href="#" class="menu-item"><i class="ik ik-menu"></i>التاريخ المرضي</a>
        <a href="#" class="menu-item"><i class="ik ik-menu"></i>اختبار OASES</a>
        <a href="#" class="menu-item"><i class="ik ik-menu"></i>اختبار SSI-4 </a>
        <a href="#" class="menu-item"><i class="ik ik-menu"></i>حجز موعد مع المختص</a>
      </div>
    </div>

    <div class="nav-item has-sub ">
      <a href="javascript:void(0)"><img src="assets/images/medicinee.png" class="img-fluid" alt="SEU">
        <span> خدمة العلاج</span>
      </a>
      <div class="submenu-content">
        <a href="#" class="menu-item"><i class="ik ik-menu"></i>التعريف بالخدمة</a>
        <a href="#" class="menu-item"><i class="ik ik-menu"></i>الدفع </a>

      </div>
    </div>

    <div class="nav-item has-sub ">
      <a href="javascript:void(0)"><img src="assets/images/healthcare.png" class="img-fluid" alt="SEU">
        <span> الجلسات العلاجية</span>
      </a>
      <div class="submenu-content">
        <a href="#" class="menu-item"> <i class="ik ik-menu"></i> المرحلة العلاجية الأولي</a>
        <a href="#" class="menu-item"><i class="ik ik-menu"></i> المرحلة العلاجية الثانية</a>
        <a href="#" class="menu-item"><i class="ik ik-menu"></i> التشخيص العلاجي النهائي</a>


      </div>
    </div> -->
  </nav>
</div>
